import { render } from "./ManuManage.vue?vue&type=template&id=5c851a74"
import script from "./ManuManage.vue?vue&type=script&lang=js"
export * from "./ManuManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__